import { AddPartPaymentSagas } from 'us.collection.partpayments/sagas/AddPartPayment'

export default [
    ...AddPartPaymentSagas
]